module.exports = __webpack_public_path__ + "img/time-attendance.44d9de77.png";